import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Ascending = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Ascending' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M12.0809 7.28641L12.4345 6.93286L12.788 7.28641L17 11.4984L16.2929 12.2055L12.9345 8.84707V16.9999H11.9345V8.84707L8.57605 12.2055L7.86895 11.4984L12.0809 7.28641Z' fill='#000' />
  </StyledIcon>
);
